'use client';

import { useMemo, useState } from 'react';
import CalculatorInputs from './CalculatorInputs';
import ResultsDisplay from './ResultsDisplay';
import { calculateSolidity } from './calculations';
import { SolidityValues } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface Props {
  translations: ToolsTranslations['solidity'];
}

export default function SolidityCalculator({ translations }: Props) {
  const [values, setValues] = useState<SolidityValues>({
    equity: 4000000,
    totalAssets: 10000000,
    currency: 'kr',
  });

  const handleValuesChange = (field: keyof SolidityValues, value: number | string) => {
    setValues(prev => ({ ...prev, [field]: value }));
  };

  const result = useMemo(() => calculateSolidity(values, translations), [values, translations]);

  return (
    <section id="solidity-calculator" className="w-full my-12 tools">
      <div className="rounded-xl border border-gray-200 shadow-sm bg-white">
        <div className="p-6 border-b border-gray-100">
          <div className="flex items-center justify-between gap-4">
            <div>
              <h2 className="text-xl font-semibold text-blue-900">{translations.title}</h2>
              <p className="text-sm text-gray-600 mt-1">{translations.subtitle}</p>
            </div>
          </div>
        </div>
        <div className="p-6 space-y-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <CalculatorInputs values={values} onValuesChange={handleValuesChange} translations={translations} />
            <ResultsDisplay
              result={result}
              translations={translations}
              equity={values.equity}
              totalAssets={values.totalAssets}
              currency={values.currency}
            />
          </div>
        </div>
      </div>
    </section>
  );
}


